import React, { FC } from 'react'
import { Typography } from '@mui/material'
import Link from 'next/link'
import Footer from './Footer'
import Header from './Header'
import LoginForm from './LoginForm'
import panier from '@assets/images/img-panier-connection.png'
import panierWebP from '@assets/images/img-panier-connection.webp'
import routes from '@const/routes'
import AlertInfo from '@components/alert/info'

const Login: FC = () => {
  return (
    <div className="relative top-[50px] flex h-full flex-col">
      <div className="mx-auto mb-6 sm:w-[80%] mobile:w-11/12">
        <AlertInfo>
          <Typography>
            Attention, si vous possédiez un compte Super-Ya sur l'ancien site, veuillez utiliser les mêmes identifiants.
            <br />
            Vous avez oublié ces identifiants ? N'hésitez pas à nous contacter en cliquant ici&nbsp;
            <Link href="/contact" className="whitespace-nowrap underline">
              Contactez-nous
            </Link>
          </Typography>
        </AlertInfo>
      </div>
      <div className="z-10 mb-24.5 flex flex-col items-center justify-between">
        <Header title="Je me connecte" subtitle="Accédez à votre espace client." />
        <div className="mt-[50px] sm:w-[350px] mobile:w-11/12">
          <LoginForm />
        </div>
        <div className="mt-[40px] mobile:w-11/12">
          <Footer help="Pas de compte Super Ya ?" action="Créez le votre, c'est rapide !" ctaLabel="Je crée mon compte" ctaTarget={routes.creer_un_compte.uri} />
        </div>
      </div>
      <div className="absolute left-0 top-[348px] z-0 responsive:hidden">
        <picture>
          <source srcSet={panierWebP.src} type="image/webp" />
          <img src={panier.src} alt="panier connexion" />
        </picture>
      </div>
    </div>
  )
}

export default Login
